import React, { useState, useEffect } from 'react';
import landingPageBackground from '../images/LandingPageBackground.png';
import mobileLandingPageBackground from '../images/MobileScreen/LandingPageForMobile.png';
import tabletLandingPageBackground from '../images/MobileScreen/tabletlandingpage.png';
import overlayImage from '../images/MobileScreen/overlayonlandingpage.png';
import heroImage from '../images/Hero.png';
import buttonCircle from '../images/buttoncircle.png';
import Navbar from './Navbar';
import { FaArrowRight } from "react-icons/fa";
import { FaCirclePlay } from "react-icons/fa6";

function LandingPagee({ scrollToServices, scrollToTrainers, scrollToTrainingZone, scrollToContact }) {
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSmallMobile = windowWidth >= 320 && windowWidth <= 480;
  const isMobile = windowWidth <= 480;
  const isMediumMobile = windowWidth >= 481 && windowWidth <= 767;
  const isLargePhone = windowWidth >= 768 && windowWidth <= 991;
  const isTablet = windowWidth >= 768 && windowWidth <= 1024;
  const isTinyMobile = windowWidth < 320;
  
  // Background image logic
  const getBackgroundImage = () => {
    if (isMobile || isMediumMobile || isLargePhone) {
      return mobileLandingPageBackground;
    } else if (isTablet) {
      return tabletLandingPageBackground;
    } else {
      return landingPageBackground;
    }
  };
  
  const backgroundImage = getBackgroundImage();
  const mainContentStyle = {
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: (isMobile || isMediumMobile || isLargePhone) ? 'space-between' : 
                    isTablet ? 'flex-start' : 'flex-start',
    paddingLeft: isSmallMobile ? '15px' : 
                 (isMobile || isMediumMobile) ? '20px' : 
                 isLargePhone ? '40px' : 
                 isTablet ? '60px' : 
                 '150px',
    paddingRight: isSmallMobile ? '15px' : 
                  (isMobile || isMediumMobile) ? '20px' : 
                  isLargePhone ? '30px' : 
                  isTablet ? '40px' : 
                  '50px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    backgroundColor: '#1E1E1E',
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center right',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
  };

  const navbarContainerStyle = {
    position: 'absolute',
    top: '0',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    zIndex: 3,
    display: 'flex',
    justifyContent: 'center',
  };

  const heroSectionStyle = {
    maxWidth: isSmallMobile ? '90%' : 
              isMobile ? '80%' : 
              isMediumMobile ? '85%' : 
              isLargePhone ? '90%' : 
              isTablet ? '70%' : 
              '800px',
    textAlign: 'left', // Keep left aligned for both mobile and desktop
    position: 'relative',
    zIndex: 10, // Higher z-index to appear above overlay
    marginLeft: isSmallMobile ? '0px' : 
                isMobile ? '20px' : 
                isMediumMobile ? '30px' : 
                isLargePhone ? '20px' : 
                isTablet ? '0px' : 
                '0',
    paddingTop: isSmallMobile ? '380px' : 
                isMobile ? '420px' : 
                isMediumMobile ? '400px' : 
                isLargePhone ? '650px' : 
                isTablet ? '820px' : 
                '180px', // Top positioning for mobile
  };

  const heroTitleStyle = {
    fontSize: isSmallMobile ? '28px' : 
              isMobile ? '40px' : 
              isMediumMobile ? '48px' : 
              isLargePhone ? '52px' : 
              isTablet ? '56px' : 
              '60px', // Responsive title size
    fontWeight: 'bold',
    lineHeight: 1.1,
    marginBottom: isSmallMobile ? '15px' : '20px',
    textTransform: 'uppercase',
    color: '#e0e0e0',
    fontFamily: 'Arial, sans-serif',
    wordSpacing: '2px',
    letterSpacing: isSmallMobile ? '0.5px' : '1px',
  };

  const heroDescriptionStyle = {
    fontSize: isSmallMobile ? '12px' : 
              isMobile ? '12px' : 
              isMediumMobile ? '16px' : 
              isLargePhone ? '17px' : 
              isTablet ? '19px' : 
              '18px',
    lineHeight: 1.6,
    marginBottom: isSmallMobile ? '18px' : 
                  (isMobile || isMediumMobile || isLargePhone) ? '20px' : 
                  isTablet ? '30px' : 
                  '40px',
    maxWidth: isSmallMobile ? '100%' : 
              (isMobile || isMediumMobile || isLargePhone) ? '100%' : 
              isTablet ? '600px' : 
              '500px',
    color: '#c0c0c0',
    margin: isSmallMobile ? '0 0 18px 0' : 
            (isMobile || isMediumMobile || isLargePhone) ? '0 0 20px 0' : 
            isTablet ? '0 0 30px 0' : 
            '0 0 40px 0', // Left aligned for mobile too
  };

  const wordAnimationStyle = {
    display: 'inline-block',
    opacity: 1,
    animation: 'slideInUp 0.8s ease-out forwards',
  };

  const ctaButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#22C55E',
    border: '2px solid #fff',
    borderRadius: '50px',
    padding: '10px 20px',
    color: '#fff',
    fontSize: '16px',
    cursor: 'pointer',
    boxShadow: '4px 4px 0 #000',
    margin: '0',
    transition: 'all 0.3s ease',
    fontWeight: 'bold',
  };

  const heroImageStyle = {
    position: 'absolute',
    right: isSmallMobile ? '-40px' : 
           isMobile ? '-50px' : 
           isMediumMobile ? '-30px' : 
           isLargePhone ? '0px' : 
           isTablet ? '5%' : 
           '10%',
    bottom: isSmallMobile ? '15px' : 
            (isMobile || isMediumMobile || isLargePhone) ? '10px' : 
            isTablet ? '0px' : 
            0,
    height: isSmallMobile ? '75%' : 
            isMobile ? '80%' : 
            isMediumMobile ? '85%' : 
            isLargePhone ? '88%' : 
            isTablet ? '85%' : 
            '90%',
    width: (isSmallMobile || isMobile || isMediumMobile || isLargePhone || isTablet) ? 'auto' : 'auto',
    objectFit: 'contain',
    zIndex: 0, // Above overlay but below hero text
    pointerEvents: 'none',
    display: 'block', // Show on mobile now
  };

  const watchVideoStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: isSmallMobile ? '6px' : 
         isMobile ? '5px' : 
         isMediumMobile ? '8px' : 
         isLargePhone ? '10px' : 
         isTablet ? '12px' : 
         '10px',
    cursor: 'pointer',
    fontSize: isSmallMobile ? '11px' : 
              isMobile ? '12px' : 
              isMediumMobile ? '16px' : 
              isLargePhone ? '18px' : 
              isTablet ? '19px' : 
              '20px',
    fontWeight: 500,
    color: '#e0e0e0',
    fontFamily: 'Arial, sans-serif',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: (isSmallMobile || isMobile || isMediumMobile || isLargePhone) ? `url(${overlayImage})` : 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    zIndex: 1, // Below hero section content
    pointerEvents: 'none',
    display: (isSmallMobile || isMobile || isMediumMobile || isLargePhone) ? 'block' : 'none',
  };


  return (
    <main id="landingPage" style={mainContentStyle}>
      {/* Overlay image for mobile screens */}
      <div style={overlayStyle}></div>
      
      <div style={navbarContainerStyle}>
        <Navbar 
          scrollToTrainers={scrollToTrainers}
          scrollToAbout={scrollToServices} // About Us will scroll to Services
          scrollToTrainingZone={scrollToTrainingZone}
          scrollToContact={scrollToContact}
        />
      </div>
      <section style={heroSectionStyle}>
        <h1 style={heroTitleStyle}>
          <span style={{ ...wordAnimationStyle, animationDelay: '0.2s' }}>BUILD YOUR</span><br />
          <span style={{ ...wordAnimationStyle, animationDelay: '0.5s', color: '#54B73D', fontSize: isSmallMobile ? '28px' : isMobile ? '40px' : isMediumMobile ? '48px' : isLargePhone ? '52px' : isTablet ? '56px' : '60px' }}>BODY SHAPES</span><br />
          <span style={{ ...wordAnimationStyle, animationDelay: '0.8s' }}>
            WITH <span style={{ color: '#54B73D', fontSize: isSmallMobile ? '28px' : isMobile ? '40px' : isMediumMobile ? '48px' : isLargePhone ? '52px' : isTablet ? '56px' : '60px' }}>FITNESS</span>
          </span>
        </h1>
        <p style={heroDescriptionStyle}>
          Build your body shape with fitness and transform your life with strength, health, and confidence.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: isSmallMobile ? '12px' : isMobile ? '15px' : isMediumMobile ? '20px' : isLargePhone ? '25px' : isTablet ? '35px' : '30px', flexDirection: 'row', justifyContent: 'flex-start' }}>
          <button
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#54B73D',
              border: '2px solid #fff',
              borderRadius: '50px',
              padding: isSmallMobile ? '0 12px' : 
                       isMobile ? '0 10px' : 
                       isMediumMobile ? '0 15px' : 
                       isLargePhone ? '0 18px' : 
                       isTablet ? '0 22px' : 
                       '0 20px',
              color: '#fff',
              fontSize: isSmallMobile ? '11px' : 
                        isMobile ? '12px' : 
                        isMediumMobile ? '16px' : 
                        isLargePhone ? '18px' : 
                        isTablet ? '19px' : 
                        '20px',
              cursor: 'pointer',
              boxShadow: '4px 4px 0 #000',
              margin: 0,
              transition: 'all 0.3s ease',
              fontWeight: 'bold',
              fontFamily: 'Arial, sans-serif',
              whiteSpace: 'nowrap',
              minWidth: isSmallMobile ? '110px' : 
                        isMobile ? '100px' : 
                        isMediumMobile ? '130px' : 
                        isLargePhone ? '150px' : 
                        isTablet ? '170px' : 
                        '160px',
              height: isSmallMobile ? '42px' : 
                      isMobile ? '40px' : 
                      isMediumMobile ? '55px' : 
                      isLargePhone ? '62px' : 
                      isTablet ? '75px' : 
                      '70px',
              position: 'relative',
              overflow: 'visible'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#16A34A';
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '2px 2px 0 #000';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#22C55E';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '4px 4px 0 #000';
            }}
            onClick={scrollToServices}
          >
            <span style={{ marginRight: isSmallMobile ? '10px' : isMobile ? '10px' : isMediumMobile ? '12px' : isLargePhone ? '16px' : isTablet ? '20px' : '20px', color: '#1E1E1E', fontWeight: 'bold' }}>Get Started</span>
            <span
              style={{
                width: isSmallMobile ? '26px' : 
                       isMobile ? '24px' : 
                       isMediumMobile ? '32px' : 
                       isLargePhone ? '36px' : 
                       isTablet ? '42px' : 
                       '40px',
                height: isSmallMobile ? '26px' : 
                        isMobile ? '24px' : 
                        isMediumMobile ? '32px' : 
                        isLargePhone ? '36px' : 
                        isTablet ? '42px' : 
                        '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                borderRadius: '50%',
                boxSizing: 'border-box',
                marginLeft: isSmallMobile ? '8px' : 
                           isMobile ? '5px' : 
                           isMediumMobile ? '8px' : 
                           isLargePhone ? '9px' : 
                           isTablet ? '12px' : 
                           '10px'
              }}
            >
              <FaArrowRight color="#1E1E1E" size={isSmallMobile ? 16 : isMobile ? 14 : isMediumMobile ? 20 : isLargePhone ? 24 : isTablet ? 30 : 28} />
            </span>
          </button>
          <div 
            style={watchVideoStyle}
            onClick={() => window.open('https://www.youtube.com/c/FUTUREFITNESSGYM', '_blank')}
          >
            <FaCirclePlay size={isSmallMobile ? 20 : isMobile ? 18 : isMediumMobile ? 24 : isLargePhone ? 28 : isTablet ? 34 : 32} color="#fff" style={{ filter: 'drop-shadow(0 0 2px #000)' }} />
            <span>Watch Our Fitness</span>
          </div>
        </div>
      </section>
      <img src={heroImage} alt="Hero" style={heroImageStyle} />
    </main>
  );
}

export default LandingPagee;
